import { graphql } from "~/gql";

export const TASK_FRAGMENT = graphql(/* GraphQL */ `
  fragment TaskParts on Task {
    __typename
    createdAt
    phaseId
    updatedAt
    id
    title
    html
    order
    markedComplete
    startDate
    deadlineDate
  }
`);
